// TODO: Delete this FF after new PII API is fully rolled out
const isNewPiiDataEnabled = () => process.env.REACT_APP_USE_NEW_PII_API === 'true';

// TODO: Delete this FF after Regula verification is fully rolled out
const isRegulaEnabled = () => process.env.REACT_APP_USE_REGULA_VERIFICATION === 'true';

const isSsoEnabled = () => process.env.REACT_APP_DISABLE_SSO !== 'true';

const isChinaRegion = () => process.env.REACT_APP_REGION === 'CHINA';

const isRSScreenDetectionEnabled = () =>
  process.env.REACT_APP_ENABLE_ROOM_SCAN_SCREEN_DETECTION === 'true';

export {
  isNewPiiDataEnabled,
  isRegulaEnabled,
  isSsoEnabled,
  isChinaRegion,
  isRSScreenDetectionEnabled
};
